module.exports = __webpack_public_path__ + "img/矩形 2944.9160afc3.png";